import { $t } from '@/i18n';
export const jobSchema = {
    type: 'object',
    id: 'job',
    title: $t('k_4fe45eb8'),
    fields: [
        { id: 'id', type: 'string', title: $t('k_3ad57267') },
        { id: 'title', type: 'string', title: $t('k_e7c729c4') },
        { id: 'status', type: 'string', title: $t('k_4fd3370b') },
        { id: 'params', type: 'object', title: $t('k_d504e954'), fields: [] },
        { id: 'state', type: 'object', title: $t('k_a3f12f59'), fields: [] },
        { id: 'nodes', type: 'object', title: $t('k_8d3c0d1f'), fields: [] },
        { id: 'message', type: 'string', title: $t('k_7a43682c') },
        { id: 'creator', type: 'string', title: $t('k_6cf18673') },
        { id: 'currentApprovers', type: 'string', title: $t('k_14e01ff1') },
        { id: 'relatedUsers', type: 'string', title: $t('k_fa394825') },
        { id: 'flowId', type: 'string', title: $t('k_b809779') },
        { id: 'ctime', type: 'string', title: $t('k_3a4f696d') },
        { id: 'envId', type: 'string', title: $t('k_6ac42065') },
        { id: 'url', type: 'string', title: $t('k_53ed26e4') },
        {
            id: 'detailBlocks', type: 'array', title: $t('k_8e55351a'),
            items: {
                type: 'object',
                fields: [
                    { id: 'title', type: 'string', title: $t('k_f40ef4e7') },
                    { id: 'ctime', type: 'number', title: $t('k_47fb1a2c') },
                    { id: 'nodeId', type: 'string', title: $t('k_63052eef') },
                    { id: 'type', type: 'string', title: $t('k_d583610a') },
                    // { id: 'nodePagelet', type: 'string', title: '对应页面片ID' },
                ],
            },
        },
        {
            id: 'reload', type: 'methods', title: $t('k_66b0b5ef'),
        },
        {
            id: 'isWaitingForNextBlock', type: 'boolean', title: $t('k_afb8249'),
        },
    ],
};
